module.exports = __webpack_public_path__ + "static/img/3-active.728f6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/3-active.png
// module id = rLip
// module chunks = 0